export const SearchFilterTranspose = data => {
  const transposeOptions = options => {
    return options.map(_ref => {
      let {
        label,
        id,
        value,
        description
      } = _ref;
      return {
        __typename: 'MarketplaceFilterOption',
        label,
        id,
        value,
        description: description || ''
      };
    });
  };
  return {
    marketplaceFilters: {
      __typename: 'MarketplaceFilters',
      product: transposeOptions(data.product),
      hosting: transposeOptions(data.hosting),
      price: transposeOptions(data.price),
      trustSignals: transposeOptions(data.trustSignals),
      other: transposeOptions(data.other),
      categories: transposeOptions(data.categories),
      useCases: transposeOptions(data.useCases)
    }
  };
};